import { Button } from './ui/button';
import { Dialog, DialogContent, DialogClose } from './ui/dialog';
import { RxCross1 } from 'react-icons/rx';

export type ConfirmRestartVariant = 'resume' | 'freshStart';

const WORDING_BY_VARIANT: Record<
  ConfirmRestartVariant,
  {
    title: string;
    body: string;
    restartButton: string;
    resumeButton?: string;
  }
> = {
  resume: {
    title: 'Abandonner le questionnaire en cours ?',
    body: 'Vous avez déjà un questionnaire en cours. Si vous recommencez, vos réponses actuelles seront perdues.',
    restartButton: 'Abandonner et recommencer',
    resumeButton: 'Continuer le questionnaire en cours',
  },
  freshStart: {
    title: 'Démarrer un nouveau questionnaire ?',
    body: 'Un questionnaire est déjà en cours sur cet appareil. En démarrer un nouveau effacera ses réponses.',
    restartButton: 'Démarrer un nouveau',
  },
};

export const ConfirmRestartQuestionnaireModal = ({
  show,
  onClose,
  onConfirm,
  variant = 'resume',
}: {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  variant?: ConfirmRestartVariant;
}) => {
  const wording = WORDING_BY_VARIANT[variant];
  const hasResumePath = Boolean(wording.resumeButton);

  return (
    <Dialog
      open={show}
      onOpenChange={(open) => !open && hasResumePath && onClose()}
    >
      <DialogContent className="nsm:w-[752px]">
        <div className="h-6 flex justify-end">
          {hasResumePath && (
            <DialogClose
              className="h-10 cursor-pointer focus:ring-0 focus:outline-hidden"
              onClick={onClose}
            >
              <RxCross1 className="size-5" />
            </DialogClose>
          )}
        </div>
        <div className="px-5 nsm:px-8">
          <div className="flex flex-col justify-center gap-3">
            <p className="text-xl font-medium">{wording.title}</p>
            <div className="flex flex-col">
              <p className="font-light">{wording.body}</p>
            </div>
            <div className="flex flex-col nsm:flex-row justify-center items-center gap-3 mt-4">
              {wording.resumeButton && (
                <Button variant="ctaSecondary" size="lg" onClick={onClose}>
                  {wording.resumeButton}
                </Button>
              )}
              <Button variant="ctaPrimary" size="lg" onClick={onConfirm}>
                {wording.restartButton}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
